import apiClient from "../services/ApiClient";
import React, {useEffect, useRef, useState} from "react";
import {components} from "../types/OnuoGate";
import {
    Alert,
    Button, Card,
    DatePicker, Descriptions, Form, FormProps,
    GetProp, InputNumber, Modal, notification,
    Popconfirm, Popover, Select,
    Space, Table,
    TableProps, Tag,
} from "antd";
import {Link, useLocation, useNavigate, useParams} from "react-router-dom";
import {getTableColumns} from "../components/EditModal";
import {TableRowSelection} from "antd/es/table/interface";
import {DeleteFilled,InfoOutlined,WarningOutlined} from "@ant-design/icons";
import {
    ActionType,
    ProCard,
    ProColumns,
    ProForm, ProFormCheckbox,
    ProFormSelect,
    ProFormText,
    ProTable
} from "@ant-design/pro-components";
import SelectLogoDevice from "../components/SelectLogoDevice";
import {EllipsisOutlined, PlusOutlined, CloudDownloadOutlined} from '@ant-design/icons';

const {RangePicker} = DatePicker;

interface TableParams {
    pagination?: TablePaginationConfig;
    filters?: Parameters<GetProp<TableProps, "onChange">>[1];
}

type ColumnsType<T extends object = object> = TableProps<T>["columns"];
type TablePaginationConfig = Exclude<
    GetProp<TableProps, "pagination">,
    boolean
>;

export default function OrderItems(_props: any) {
    const params = useParams<{ id: string }>();
    const navigate = useNavigate();
    const {state} = useLocation();
    const [api, contextHolder] = notification.useNotification();

    const [latestRequestParams, setLatestRequestParams] = useState("");

    const tableRef = useRef<ActionType>(null);

    const [showChangeDeviceCodeModal, setShowDeviceCodeModal] = useState<
        components["schemas"]["OpenOrderLine"] | null
    >(null);


    const onFinishChangeHandcode: FormProps<
        components["schemas"]["ChangeOrderHandCodeRequest"]
    >["onFinish"] = async (values) => {
        const response = await apiClient.changeLogoHandset(
            {id: showChangeDeviceCodeModal?.id || 0},
            values,
        );

        if (response.status == 200) {
            api.success({
                message: `Başarıyla Değiştirildi`,
                type: "success",
                duration: 3,
            });
        }

        setShowDeviceCodeModal(null);
    };
    const onFinishChangeHandcodeFailed: FormProps<
        components["schemas"]["ChangeOrderHandCodeRequest"]
    >["onFinishFailed"] = (errorInfo) => {
        console.log("Failed:", errorInfo);
    };
    
    
    const [isDevMode, setIsDevMode] = useState(false);

    const baseColumns = getTableColumns(
        setShowDeviceCodeModal,
        () => {
        },
        (obj) => {
            return (
                <Space size="middle">
                    <Link target={"_blank"} to={"/orders/modal/" + obj.openOrder?.id}>
                        <Button type={"primary"} variant={"solid"}>
                            Detaya Git
                        </Button>
                    </Link>

                   {/* <Button
                        onClick={() => {
                            console.log(obj);
                        }}
                        type={"primary"}
                        variant={"solid"}
                    >
                        Düzenle
                    </Button>*/}

                  {/*  <Popconfirm
                        title="Satış Kiti"
                        description="Satış kiti Silinecektir"
                        //onConfirm={() => deleteSaleKit(obj)}
                        okText="Sil"
                        cancelText="İptal"
                    >
                        <Button
                            type={"primary"}
                            color={"red"}
                            variant={"solid"}
                            icon={<DeleteFilled/>}
                        >
                            Sil
                        </Button>
                    </Popconfirm>*/}
                </Space>
            );
        },
        isDevMode
    );

   
    
    useEffect(() => {
        // Global'e aktar
        (window as any).setDevMode = setIsDevMode;
        (window as any).isDevMode = isDevMode;
    }, [isDevMode]);

    const cellFn = (_: components["schemas"]["OpenOrderLine"]) => {
        return {
            style: {
                background: _.status == 1 ? 'red' : (_.status == 2 ? 'green' : ''),
            }
        }
    }

    let columns: ProColumns<components["schemas"]["OpenOrderLine"]>[];
    columns = [
        {
            title: 'Gönderim Adresi',
            hideInTable: true,
            dataIndex: 'addressClientRefStatus',
            valueType: 'radio',
            valueEnum: {
                "-1": 'Hepsi',
                null: 'Normal',
                true: 'Bayi Adresine'
            }
        },
        {
            width: 100,
            dataIndex: ["openOrder", "firmFranchiseCode"],
            title: "Bayi Kodu",
            fixed: "left",
            onCell: cellFn,
            render: (_, record) => (
                <Popover content={record.franchiseName}>

                    {_}
                </Popover>

            )
        },
        {
            width: 100,
            dataIndex: ["storeName"],
            title: "Alt Bayi Kodu",
            fixed: "left",
            render: (_, record) => {
                if(record.addressClientRef!=null){
                    return (
                        <Popover content={<>Farklı Adrese Gönderiliyor = <Tag>{record.addressCode}</Tag></>}>
                            <Tag color={'green'}>{_} X</Tag>
                        </Popover>
                    )
                }
                
                return (
                    <Tag color={record.openOrder?.firmFranchiseCode != record.storeName ? 'red' : 'blue'}>{_}</Tag>
                )
            }
        },
        {
            width: 100,
            dataIndex: "recid",
            title: "rec Kodu",
        },
        {
            width: 100,
            dataIndex: "status",
            title: "İşlenecek mi?",
            valueType: 'radio',
            valueEnum: {
                0: 'Aktif',
                1: 'Pasif',
                2: 'Stok Bekleniyor',

            },
            hideInTable: true
        },
        /*  {
              title: "Oluşturulma Tarihi",
              dataIndex: ["openOrder", "orderDate"],
              valueType: "dateTimeRange",
              render: (text, record) => {
                  return new Date(record.openOrder?.orderDate ?? "").toLocaleString();
              },
          },*/
        ...baseColumns,
    ];

    const [dataSource, setDataSource] = useState<
        components["schemas"]["OpenOrderLine"][]
    >([]);

    const [loading, setLoading] = useState(false);


    /*
          useEffect(() => {
              const fetch = async () => {
                  setLoading(true);
      
                  const response = await apiClient.getOrderLines({
                      Page: tableParams.pagination?.current || 1,
                      PageSize: tableParams.pagination?.pageSize || 10,
                      Filter: JSON.stringify(tableParams.filters),
                  });
      
                  // @ts-ignore
                  setDataSource(response.data.data || []);
                  setTableParams({
                      ...tableParams,
                      pagination: {
                          current: response.data.page || 1,
                          pageSize: response.data.pageSize || 10,
                          total: response.data.totalData || 0,
                      },
                  })
                  setLoading(false);
              }
              fetch();
          }, [
              tableParams.pagination?.current,
              tableParams.pagination?.pageSize,
              JSON.stringify(tableParams.filters),
          ]);*/

    const [selectedRows, setSelectedRows] = useState<components["schemas"]["OpenOrderLine"][]>([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [isBulkModalOpen, setIsBulkModalOpen] = useState<boolean>(false);

    const onSelectChange = (
        newSelectedRowKeys: React.Key[],
        newSelectedRows: components["schemas"]["OpenOrderLine"][]
    ) => {
        console.log("selectedRowKeys changed: ", newSelectedRowKeys);
        console.log("selectedRows changed: ", newSelectedRows);

        setSelectedRowKeys(newSelectedRowKeys);
        setSelectedRows(newSelectedRows);
    };

    const rowSelection: TableRowSelection<components["schemas"]["OpenOrderLine"]> = {
        selectedRowKeys,
        onChange: onSelectChange,
    };


    const [handcodeForm] = Form.useForm();
    const [deliveryAddressForm] = Form.useForm();


    const [addressKeyValMap, setAddressKeyValMap] = useState<Map<number, string>>(new Map());

    return (
        <div>
            <Modal
                open={showChangeDeviceCodeModal != null}
                width={"1200px"}
                onOk={handcodeForm.submit}
                onCancel={() => setShowDeviceCodeModal(null)}
            >
                <Form
                    form={handcodeForm}
                    labelCol={{span: 8}}
                    wrapperCol={{span: 16}}
                    onFinish={onFinishChangeHandcode}
                    onFinishFailed={onFinishChangeHandcodeFailed}
                    autoComplete="off"
                >

                    <Form.Item<components["schemas"]["SaleKitRequest"]>
                        label={
                            showChangeDeviceCodeModal?.deviceCode == ""
                                ? "Satış Kiti"
                                : "Değiştirilecek Ürün"
                        }
                        name="logicalRef"
                        initialValue={showChangeDeviceCodeModal?.ounoLogicalRef}
                        rules={[{required: true}]}
                    >
                        <SelectLogoDevice/>
                    </Form.Item>

                    {showChangeDeviceCodeModal?.deviceCode == "" && (
                        <>
                            <Form.Item<components["schemas"]["SaleKitRequest"]>
                                initialValue={showChangeDeviceCodeModal.siparisMiktar}
                                name={"orderStock"}
                                label={"Adet"}
                            >
                                <InputNumber/>
                            </Form.Item>
                        </>
                    )}
                </Form>
            </Modal>
            {contextHolder}


            <ProTable<components["schemas"]["OpenOrderLine"]>
                //onChange={handleTableChange}
                actionRef={tableRef}
                rowSelection={rowSelection}
                scroll={{ y: '600px', x: 'max-content' }}
                headerTitle={
                    <>
                        <Popover content={<Card title={"Bilgi"}>
                            <Alert message="Kırmızı İşararetliler İşleme Dahil Edilmeyecektir" type="warning"/>
                            <Alert message="Yeşil  İşararetliler İşleme Dahil Edilmeyecektir-Stok Bekleniyor"
                                   type="success"/>
                        </Card>}>
                            <Button icon={<InfoOutlined />} color={'primary'} variant={'dashed'}>Renk Açıklamaları</Button>
                        </Popover>
                   
                    </>

                }
                search={{
                    defaultCollapsed: false,
                    span: 8
                }}
                toolBarRender={() => {
                    return [
                        selectedRowKeys.length > 0 && (
                        <Popover content={<>
                            <Card style={{maxHeight: '60vh',overflowY: 'auto'}} title={'Sevk Adresleri Güncelleme'}>
                                <Form form={deliveryAddressForm} onFinish={async (values) => {

                                    const response = await apiClient.updateDeliveryAddress({
                                        deliveryAddress: values
                                    })

                                    tableRef.current?.reload();
                                    
                                    
                                }}>


                                    <table>
                                        <tr>
                                            <th>
                                                Bayi Adı - Bayi Kodu
                                            </th>
                                            <th>
                                                Hedef Adres
                                            </th>
                                        </tr>
                                        {
                                            selectedRows.map(x => {
                                                if (x.id == undefined) {
                                                    return null;
                                                }
                                                return (
                                                    <tr>
                                                        <td>
                                                            {x.franchiseName} - {x.openOrder?.firmFranchiseCode} - <Tag>{x.storeName}</Tag>
                                                        </td>
                                                        <td style={{width: '600px'}}>
                                                            <Form.Item label={null} name={[x.id, 'code']}>
                                                                <input type="hidden" value={""}/>
                                                            </Form.Item>
                                                            <ProFormSelect
                                                                initialValue={x.addressClientRef}
                                                                showSearch={true}
                                                                name={[x.id, 'deliveryAddress']}
                                                                label="Yeni Adres"
                                                                request={async (params, props) => {

                                                                    const response = await apiClient.searchLogoAddress({
                                                                        firmCode: x.openOrder?.firmFranchiseCode || ""
                                                                    })

                                                                    const valMap = new Map<number, string>();

                                                                    response.data.forEach(item => {
                                                                        valMap.set(item.logicalRef || 0, item.code || "");
                                                                    });


                                                                    setAddressKeyValMap(valMap)


                                                                    return response.data.map(x => ({
                                                                        value: x.logicalRef,
                                                                        label: (
                                                                            <Popover placement={'left'} content={
                                                                                <Card style={{width: '400px'}}>
                                                                                    <Descriptions column={1} items={[
                                                                                        {
                                                                                            label: 'Kod',
                                                                                            children: x.code
                                                                                        },

                                                                                        {
                                                                                            label: 'Başlık',
                                                                                            children: x.name
                                                                                        },
                                                                                        {
                                                                                            label: 'Adres',
                                                                                            children: x.addr1
                                                                                        },
                                                                                        {
                                                                                            label: 'İl',
                                                                                            children: x.city
                                                                                        }
                                                                                    ]}/>
                                                                                </Card>}
                                                                            >
                                                                                <Tag>{x.code}-{x.title}</Tag>
                                                                            </Popover>
                                                                        )
                                                                    }));
                                                                }}
                                                                onChange={(value: number) => {
                                                                    
                                                                    
                                                                    console.log("value", value, addressKeyValMap.get(value));
                                                                    console.log(deliveryAddressForm.getFieldsValue())
                                                                    deliveryAddressForm.setFieldValue([x.id, 'code'], addressKeyValMap.get(value) || "");
                                                                    console.log(deliveryAddressForm.getFieldsValue())

                                                                }}
                                                                placeholder="Teslimat Adresi"
                                                            />
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </table>


                                    <Button color={'primary'} onClick={() => {
                                        deliveryAddressForm.submit()
                                    }}>
                                        Güncelle
                                    </Button>
                                </Form>

                            </Card>
                        </>}>

                            <Button>
                                Adres Güncelle
                            </Button>
                        </Popover>
                        )
                        ,

                        selectedRowKeys.length > 0 && (
                            <Popover content={
                                <ProCard style={{minHeight: 200, marginBottom: '10px'}}>

                                    <ProForm<components["schemas"]["BulkStatusChange"]>
                                        onFinish={async (values) => {
                                            console.log("values", values);

                                            const asParsed = JSON.parse(latestRequestParams);

                                            const response = await apiClient.bulkOpenOrderLineStatusUpdate({
                                                ids: selectedRowKeys.map(x => parseInt(x.toString())),
                                                orderLineStatus: values.orderLineStatus

                                            })


                                            tableRef.current?.reload();

                                        }}
                                        submitter={{
                                            render: (data, c) => {
                                                return <div>{c}</div>;
                                            },
                                            searchConfig: {
                                                submitText: 'Güncelle',
                                            },

                                        }}
                                    >
                                        <ProFormSelect
                                            name="orderLineStatus"
                                            label="Statu"
                                            request={async (params, props) => {

                                                return [
                                                    {
                                                        value: 0,
                                                        label: 'Aktif'
                                                    },
                                                    {
                                                        value: 1,
                                                        label: 'Pasif'
                                                    },
                                                    {
                                                        value: 2,
                                                        label: 'Stok Bekleniyor'
                                                    }
                                                ]
                                            }}
                                            placeholder="Durum"
                                        />
                                    </ProForm>
                                </ProCard>
                            }>


                                <Button color={'primary'} variant={'solid'}>
                                    Durumu Değiştir
                                </Button>
                            </Popover>
                        ),
                        <Popconfirm
                            title="Vodafone Gönderilecektir"
                            description={"Bu İşlem Geri Alınamaz Listeyi Dikkatli Şekilde Kontrol Ediniz"}
                            onConfirm={async () => {

                                const asParsed = JSON.parse(latestRequestParams);

                                const response = await apiClient.bulkOpenOrderLineApprove({
                                    filter: asParsed.Filter
                                })

                                for (const x in response.data.errorList) {
                                    api.open({
                                        message: x
                                    })
                                }
                            }}
                        >
                            <Button color={'red'} variant={'solid'} icon={<WarningOutlined />}>
                                Sipariş Oluştur
                            </Button>
                        </Popconfirm>,




                        <Popover content={<ProCard style={{minHeight: 200, marginBottom: '10px'}}>
                            <ProForm
                                onFinish={async (values) => {
                                    console.log("values", values);

                                    const asParsed = JSON.parse(latestRequestParams);
                                    const response = await apiClient.bulkOpenOrderLinePayPlanUpdate({
                                        filter: asParsed.Filter,
                                        
                                        ...values
                                    })

                                    tableRef.current?.reload();

                                }}
                                submitter={{
                                    render: (data, c) => {
                                        return <div>{c}</div>;
                                    },
                                    searchConfig: {
                                        submitText: 'Güncelle',
                                    },

                                }}
                            >
                                <ProFormText label={"Kaynak Handset"} name={"handset"} initialValue=""/>
                                <ProFormSelect
                                    showSearch={true}
                                    name="newPayPlanId"
                                    label="Değiştirilecek Ödeme Planı2"
                                    request={async (params, props) => {

                                    
                                        
                                        const response = await apiClient.searchPayPlans({
                                            payplan: params.keyWords
                                        })


                                        const d=  response.data.map(x => ({
                                            value: x.logicalRef,
                                            label: x.name
                                        }));

                                        console.log('ressss',d)
                                        
                                        
                                        return d;
                                    }}
                                    placeholder="Ödeme Planı"
                                />
                                
                                

                            </ProForm>

                        </ProCard>
                        }>
                            <Button variant={'solid'} color={'green'}>
                                Ödeme Planı Değiştirme
                            </Button>
                        </Popover>,
                        
                        
                        
                        <Popover
                            mouseLeaveDelay={2}
                            content={<ProCard style={{minHeight: 200, marginBottom: '10px'}}>
                            <ProForm
                                onFinish={async (values) => {
                                    console.log("values", values);

                                    const asParsed = JSON.parse(latestRequestParams);

                                    const response = await apiClient.bulkOpenOrderLineHandsetUpdate({
                                        filter: asParsed.Filter,
                                        newHandset: values.newHandset,
                                        oldHandset: values.oldHandset,
                                        newHandsetCount: values.newHandsetCount,
                                        skipUpdated: values.skipUpdated,
                                    })


                                    tableRef.current?.reload();

                                }}
                                submitter={{
                                    render: (data, c) => {
                                        return <div>{c}</div>;
                                    },
                                    searchConfig: {
                                        submitText: 'Güncelle',
                                    },

                                }}
                            >
                                <ProFormText label={"Kaynak Handset"} name={"oldHandset"} initialValue=""/>
                                <ProFormSelect
                                    showSearch={true}
                                    name="newHandset"
                                    label="Değiştirilecek Cihaz"
                                    request={async (params, props) => {

                                        const response = await apiClient.searchLogoDevice({
                                            handset: params.keyWords
                                        })

                                        return response.data.map(x => ({
                                            value: x.logicalRef,
                                            label: x.specCode3
                                        }));
                                    }}
                                    placeholder="Değiştirilecek handcode"
                                />
                                
                                <ProFormText label={'Güncellenecek Cihaz Adeti'} name={'newHandsetCount'} placeholder={'Adet'}/>
                                    
                                <ProFormCheckbox bordered={true} label={'Güncellenmişleri Atla'} name={'skipUpdated'} help={'Sadece Ouno Device Code Alanı boş olanları günceller '}>
                                    
                                </ProFormCheckbox>
                                
                                
                                
                            </ProForm>

                        </ProCard>
                        }>
                            <Button>
                                Toplu Handset Değiştirme
                            </Button>
                        </Popover>

                        ,
                        <Button
                            key="button"
                            icon={<CloudDownloadOutlined/>}
                            onClick={async () => {

                                const response = await apiClient.getOrderLines({
                                    ...JSON.parse(latestRequestParams),
                                    IsExport: true
                                }, true);


                                const blob = new Blob([response.data as BlobPart]);

                                const fileName = `order-lines-${Date.now()}.xlsx`;

                                const link = document.createElement('a');
                                link.href = URL.createObjectURL(blob);
                                link.download = fileName;
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);


                            }}
                            type="primary"
                        >
                            Excel
                        </Button>
                    ]
                }}
                pagination={{
                    defaultPageSize: 200,
                    pageSizeOptions: [20,50,100, 250, 500, 1000]
                }}
                request={async (params, sort, filter) => {
                    debugger;
                    const {current, pageSize, ...otherFields} = params;

                    const reqParam = {
                        Page: current || 1,
                        PageSize: pageSize || 10,
                        Filter: JSON.stringify({...otherFields}),
                    };
                    setLatestRequestParams(JSON.stringify(reqParam))


                    const response = await apiClient.getOrderLines(reqParam);

                    return {
                        success: true,
                        data: response.data.data || [],
                        total: response.data.totalData || 0,
                    };
                }}
                rowKey={(x) => x.id?.toString() || "0"}
                columns={columns}
            />

        </div>
    );
}
